



















































import { KeyPair } from '@/types/KeyPair'
import { Component } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Global from "@/Global.vue"
import axios from "axios"
import User, { IUser } from "@/models/User"
import {apiV1EventsPath, apiV1UserResendConfirmationPath, apiV1UsersCurrentPath} from "@/rails/routes"
import Event, {IEvent} from "@/models/Event"

@Component({
  components: {
    Global
  }
})
export default class EntryLayout extends VueBase {
  MENUS = [
    { label: 'トップ', link: this.settings.site.top, icon: 'home', blank: true },
    { label: '求人情報', link: this.settings.site.recruit, icon: 'domain', blank: true },
    { label: 'プロフィール', link: '/mypage', icon: 'account-edit' },
    { label: 'イベント', link: '/events', icon: 'calendar-check' },
    { label: '気になる企業', link: '/favorites', icon: 'star' },
    { label: '設定', link: '/settings', icon: 'cog' },
  ]
  selected = 0
  events: Array<Event> = []

  get activateMenus(): Array<KeyPair> {
    return this.MENUS.filter(menu => this.settings.entry.menus.includes(menu.link))
  }

  get showedEventAlert(): boolean {
    return this.events.length && !window.location.href.includes('/events')
  }

  mounted(): void {
    this.reloadUser()
    this.reloadEvents()
  }

  async resendConfirmation(): Promise<void> {
    try {
      await axios.post(apiV1UserResendConfirmationPath())
      this.showMessage('認証メールを再送信しました')
    } catch {
      window.location.reload()
    }
  }

  async reloadUser(): Promise<void> {
    try {
      const res = await axios.get<IUser>(apiV1UsersCurrentPath())
      if (res.data) {
        this.$store.dispatch('setUser', new User(res.data))
        this.selected = this.activateMenus.findIndex(menu => window.location.pathname === menu.link)
      } else {
        window.location.href = '/users/sign_in'
      }
    } catch {
      window.location.href = '/users/sign_in'
    }
  }

  async reloadEvents(): Promise<void> {
    const res = await axios.get<Array<IEvent>>(apiV1EventsPath())
    this.events = res.data.map(event => new Event(event))
  }
}
